type UpgradeRequestBannerProps = {
	message: string | null
}

// Plain-text message only: React escapes it, never render it as HTML.
function UpgradeRequestBanner({ message }: UpgradeRequestBannerProps) {
	return (
		<div className='rounded-lg bg-sun-500 p-4 my-5 text-charcoal-900' role='status'>
			<p>User requested upgrade</p>
			<p>User message: {message ? message : 'none provided'}</p>
		</div>
	)
}

export default UpgradeRequestBanner
